import type { NotifyPayload } from '@dynamika/rpc-core/contracts';
import { runToast } from '@restore/tools';
import { sessionName } from '../helpers';
import { formRpcScheme } from './scheme';

/** Shows a message a scoring form asked the reader to see, if it is ours. */
export const registerFormListeners = (): (() => void) =>
  formRpcScheme.listeners.onNotify(({ sid, level, message, title }: NotifyPayload) => {
    if (sid !== sessionName()) return;

    runToast(level, message, title);
  });
